//	P R O P S

export type props___SbDigitalMenuViewPage = {

}

//	S T A T E

export interface state___SbDigitalMenuViewPage {

	digitalmenu___id: string | null,
	digitalmenu___props: any | null,
	digitalmenu___props___isLoading: boolean,

	scrollToTop___isVisible: boolean,

	md___MdDishViewModal___isOpen: boolean,
	md___MdDishViewModal___argument: string | null,

}

//	S T A T E   D E F A U L T S

export const state___SbDigitalMenuViewPage___default: state___SbDigitalMenuViewPage = {

	digitalmenu___id: null,
	digitalmenu___props: null,
	digitalmenu___props___isLoading: true,

	scrollToTop___isVisible: false,

	md___MdDishViewModal___isOpen: false,
	md___MdDishViewModal___argument: null,

}